import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { Product } from '../../types/product';
import { ProductCardComponent } from '../product-card/product-card.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [ProductCardComponent, TranslateModule],
  templateUrl: './product-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListComponent {
  products = input.required<any[]>();
  l_ClassName = input.required<string>();
  s_ClassName = input.required<string>();
  isLoading = input.required<boolean>();
  addToCart = output<any>();
  viewDetails = output<any>();

  onAddToCart(product: any) {
    this.addToCart.emit(product);
  }

  onViewDetails(product: any) {
    this.viewDetails.emit(product);
  }
}
